import { Badge } from '@hrworks/sui-core/Badge';
import { Text } from '@hrworks/sui-core/Text';

import { S } from './PersonCard.styles';
import type { PersonCardProps } from './PersonCard.types';

export const PersonCard = ({ title, subtitle, src, badgeTitle, ...otherProps }: PersonCardProps) => (
  <S.Card {...otherProps}>
    <S.Container>
      <S.PersonInfo>
        {src && <S.Image corner="circular" src={src} />}
        <div>
          {title && (
            <Text width="full" typography="labelMd">
              {title}
            </Text>
          )}
          {subtitle && (
            <Text width="full" typography="bodySm">
              {subtitle}
            </Text>
          )}
        </div>
      </S.PersonInfo>
      {badgeTitle && <Badge badgeContent={badgeTitle} />}
    </S.Container>
  </S.Card>
);
